const genders = {
  Male: {
    value: 'Male',
    label: 'Male'
  },
  Female: {
    value: 'Female',
    label: 'Female'
  },
  Other: {
    value: 'Other',
    label: 'Prefer not to say'
  }
};

export default genders;



// WEBPACK FOOTER //
// ./src/constants/genders.js